export const operator = {
  path: 'operator',
  component: () => import('@/pages/operatorManage/list'),
  meta: {
    title: '运营商管理'
  },
  children: [{
    path: '/operator/customer_details',
    component: () => import('@/pages/operatorManage/customerDetails'),
    meta: {
      title: '客户详情'
    },
  }]
};

export const operator_package = {
  path: 'operator_package',
  component: () => import('@/pages/operatorManage/packageRecharge'),
  meta: {
    title: '套餐充值'
  },
  children: [{
    path: '/operator_package/details',
    component: () => import('@/pages/operatorManage/packageRecharge/customerDetails'),
    meta: {
      title: '套餐充值 - 客户详情'
    },
  }]
}
